<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.insured}}</div>
    </v-card-title>
    <v-card-text>
      <v-flex lg6 xs12>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <template v-if="commonForm.appSalutation">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.appSalutation}}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{salutation}}</span>
              </v-flex>
            </template>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.appName}}</v-subheader>
            </v-flex>
            <v-flex xs6>
              <span>{{commonForm.appName}}</span>
            </v-flex>
        </v-layout>
        </v-container>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import { salutation } from '@/const/underwriting'
export default {
  data() {
    return {
      labels: {
        insured: 'Insured Information',
        appName: 'Name as in NRIC/Passport',
        appSalutation: 'Salutation'
      }
    }
  },
  computed: {
    commonForm() {
      return this.$store.state.claims.claimDetail.commonForm
    },
    salutation() {
      if (this.commonForm.appSalutation) {
        return salutation[this.commonForm.appSalutation]
      } else {
        return ' - '
      }
    }
  }
}
</script>

<style>

</style>
